var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "adsets-list" },
    [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "title-block" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("metaInsights.adSets"))),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "subtitle" },
            [
              _vm.campaignId
                ? [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("metaInsights.adSetsForCampaign")) +
                        ": "
                    ),
                    _c("strong", [_vm._v(_vm._s(_vm.campaignId))]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "clear-filter",
                        on: {
                          click: function ($event) {
                            return _vm.$emit("clear-filter")
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("close"),
                        ]),
                        _vm._v(
                          _vm._s(_vm.$t("metaInsights.clearFilter")) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ]
                : [_vm._v(_vm._s(_vm.$t("metaInsights.adSetsDesc")))],
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "toolbar" },
          [
            _c("DateRangePicker", {
              on: { change: _vm.loadAdSets },
              model: {
                value: _vm.dateRange,
                callback: function ($$v) {
                  _vm.dateRange = $$v
                },
                expression: "dateRange",
              },
            }),
            _vm._v(" "),
            _c(
              "SupsisButton",
              {
                attrs: { ghost: "", disabled: _vm.loading },
                on: { click: _vm.loadAdSets },
              },
              [
                _c(
                  "i",
                  {
                    staticClass: "material-icons",
                    class: { spinning: _vm.loading },
                  },
                  [_vm._v("refresh")]
                ),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("metaInsights.refresh")) +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "a-spin",
        { attrs: { spinning: _vm.loading } },
        [
          _c("InsightsTable", {
            attrs: {
              rows: _vm.adsets,
              currency: _vm.currency,
              "table-id": "meta-insights-adsets-table",
              "name-label-key": "metaInsights.col.adSet",
              clickable: true,
            },
            on: { "row-click": _vm.onRowClick },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.hasMore
        ? _c(
            "div",
            { staticClass: "load-more-wrap" },
            [
              _c(
                "SupsisButton",
                {
                  attrs: { ghost: "", disabled: _vm.loadingMore },
                  on: { click: _vm.loadMore },
                },
                [
                  _vm.loadingMore
                    ? _c("i", { staticClass: "material-icons spinning" }, [
                        _vm._v("refresh"),
                      ])
                    : _c("i", { staticClass: "material-icons" }, [
                        _vm._v("expand_more"),
                      ]),
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.loadingMore
                          ? _vm.$t("metaInsights.loading")
                          : _vm.$t("metaInsights.loadMore")
                      ) +
                      "\n        "
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }